import { createContext, useContext } from 'react';

// Single source of truth for whether the first-load preloader has finished.
// Defaults to `true` so components that render without a provider (e.g. during
// react-snap prerendering or on routes mounted after the first load) behave as
// if the intro is already done and animate normally.
export const PreloaderContext = createContext(true);

export const usePreloaderComplete = () => useContext(PreloaderContext);
